import { render, staticRenderFns } from "./FbDialog.vue?vue&type=template&id=69c2bbe0&scoped=true"
import script from "./FbDialog.vue?vue&type=script&lang=js"
export * from "./FbDialog.vue?vue&type=script&lang=js"
import style0 from "./FbDialog.vue?vue&type=style&index=0&id=69c2bbe0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c2bbe0",
  null
  
)

export default component.exports